/**
 * Componente de sección de gráficos de pedidos
 * Orders charts section component
 */

import { OrdersByPeriodChart } from './OrdersByPeriodChart';
import { TotalOrdersDonutChart } from './TotalOrdersDonutChart';
import { GlobalMetrics, DailyMetric } from '../../models/LogisticsApiResponse';

interface OrdersChartsSectionProps {
  globalMetrics?: GlobalMetrics;
  dailyMetrics?: DailyMetric[];
  isLoading?: boolean;
}

export const OrdersChartsSection = ({
  globalMetrics,
  dailyMetrics,
  isLoading = false,
}: OrdersChartsSectionProps) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-10 gap-6">
      {/* Columna izquierda - 60% (6 columnas) - Left column - 60% (6 columns) */}
      <div className="lg:col-span-6 min-w-0">
        <OrdersByPeriodChart
          globalMetrics={globalMetrics}
          dailyMetrics={dailyMetrics}
          isLoading={isLoading}
        />
      </div>

      {/* Columna derecha - 40% (4 columnas) - Right column - 40% (4 columns) */}
      <div className="lg:col-span-4 min-w-0">
        <TotalOrdersDonutChart
          globalMetrics={globalMetrics}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

